// extracted by mini-css-extract-plugin
module.exports = {"unorganizedContainer":"lYr3kEtJ","title":"__1OBbgjRC"};